import { useState } from "react";
import { toast } from "react-toastify";
import { get_file_from_s3 } from "../../utils";
import { formatDate } from "./constants";

// `fileUrl` holds whatever the upload returned: either an absolute URL (backend
// stored the file itself) or an S3 object key (our own upload path), which needs
// a presigned URL before it can be opened.
const openDocument = async (doc) => {
  const target = doc?.fileUrl || doc?.url || doc?.s3Document?.fileName;
  if (!target) {
    toast.error("This document has no file attached.");
    return;
  }
  let href = target;
  if (!/^https?:\/\//i.test(target)) {
    href = await get_file_from_s3(target);
  }
  if (!href) return; // get_file_from_s3 already toasts on failure
  window.open(href, "_blank", "noopener,noreferrer");
};

const DocumentList = ({ documents = [], onRemove, emptyText = "No documents uploaded yet." }) => {
  const [busyId, setBusyId] = useState(null);

  if (!documents.length) {
    return <p className="text-sm text-gray-400 py-4">{emptyText}</p>;
  }

  const handleView = async (doc, key) => {
    setBusyId(key);
    try {
      await openDocument(doc);
    } finally {
      setBusyId(null);
    }
  };

  return (
    <ul className="divide-y divide-gray-100 border border-gray-200 rounded-lg">
      {documents.map((doc, index) => {
        const key = doc?.id || doc?.fileUrl || `${doc?.fileName}-${index}`;
        return (
          <li key={key} className="flex items-center justify-between gap-3 px-4 py-3">
            <div className="min-w-0">
              <p className="truncate text-sm font-medium text-gray-700">
                {doc?.fileName || "Untitled document"}
              </p>
              <p className="text-xs text-gray-400">
                Uploaded {formatDate(doc?.uploadedDate, true)}
              </p>
            </div>
            <div className="flex shrink-0 items-center gap-3">
              <button
                type="button"
                onClick={() => handleView(doc, key)}
                disabled={busyId === key}
                className="text-sm font-medium text-blue-primary hover:underline disabled:opacity-50"
              >
                {busyId === key ? "Opening..." : "View"}
              </button>
              {onRemove && (
                <button
                  type="button"
                  onClick={() => onRemove(index)}
                  className="text-sm font-medium text-red-500 hover:underline"
                >
                  Remove
                </button>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default DocumentList;
